<template>
  <div class="groupInfoMain" :style="cssProps" v-if="group">
    <div class="topBar">
      <img class="closeBtn" src="@/assets/images/close4.png" @click="closeRightColumn">
      <div class="barTitle">
        Grup Bilgisi
      </div>
    </div>
    <div class="mainInfoDiv">
      <div class="profileContainer">
        <div class="profilePhotoDiv">
          <img :src="photoURL" class="avatarImg">
          <input style="display: none;" ref="groupPhotoSelectorInfo" @input="imageFilesSelectedInfo" type="file"
                 accept="image/*"
          >
          <dropdown :is-icon="false" :x="-80" :y="-200" :class-name="'photoDropDown'"
                    ref="photoDropDownInfo"
                    v-if="isGroupAdmin && !isLDAP"
          >
            <template slot="btn">
              <img src="@/assets/images/changegroupphoto.png" class="photoHover">
            </template>
            <template slot="body">
              <!-- <div class="photoMenuItem">
                Fotoğraf çek
              </div> -->
              <div class="photoMenuItem" @click="openFileDialogInfo">
                Fotoğraf yükle
              </div>
            </template>
          </dropdown>
        </div>
      </div>

      <div class="groupTitleCont">
        <div ref="groupTitle"
             class="groupTitle"
             :class="{editable: isGroupTitleInEditMode, error: isGroupTitleError}"
             :contenteditable="isGroupTitleInEditMode"
             @input="groupTitleCheck"
        >
          {{ group.GroupName }}
        </div>
        <span v-if="isGroupAdmin && !isLDAP">
          <img class="imgEdit" @click="makeGroupTitleEditable" src="@/assets/images/editpen.png"
               v-if="!isGroupTitleInEditMode"
          >
          <img class="imgEdit" @click="submitGroupTitle" src="@/assets/images/oktickgray.png" v-else>
        </span>
      </div>
      <div class="createDate">
        Oluşturulma: {{ group.CreateDate | moment("DD.MM.YYYY HH:mm") }}
      </div>
    </div>

    <div class="groupDescriptionDiv">
      <div>Açıklama</div>

      <div class="groupTitleCont">
        <div ref="groupDesc" class="groupTitle" :class="{editable: isGroupDescInEditMode}"
             :contenteditable="isGroupDescInEditMode"
        >
          {{ group.GroupDescription }}
        </div>
        <span v-if="isGroupAdmin && !isLDAP">
          <img class="imgEdit" @click="makeGroupDescEditable" src="@/assets/images/editpen.png"
               v-if="!isGroupDescInEditMode"
          >
          <img class="imgEdit" @click="submitGroupDesc" src="@/assets/images/oktickgray.png" v-else>
        </span>
      </div>
    </div>

    <div class="groupDescriptionDiv">
      <div>Mesaj Gönderebilir</div>

      <div class="participantRow">
        <div class="participantName">
          {{ groupAuthText }}
        </div>

        <dropdown :is-icon="false" :x="0" :y="0" ref="authDropdown"
                  v-if="isGroupAdmin && !isLDAP"
        >
          <template slot="btn">
            <img class="dropDownBtn" src="@/assets/images/downarrow.png">
          </template>
          <template slot="body">
            <div class="photoMenuItem" @click="changeGroupAuth(1)">
              {{ allParticipantsText }}
            </div>
            <div class="photoMenuItem" @click="changeGroupAuth(0)">
              {{ onlyAdminsText }}
            </div>
          </template>
        </dropdown>
      </div>
    </div>

    <div class="groupDescriptionDiv">
      <div class="participantRow">
        <div>{{ participantCount }} Katılımcı</div>
        <div class="addParticipant" @click="addToGroup" v-if="isGroupAdmin && !isLDAP">
          Kişi Ekle
        </div>
      </div>
      <!-- <div class="participantRow">
        <img :src="getUserPhoto(group.Owner)" alt>
        <div class="participantName">
          {{ getUserNameDisplay(group.Owner) }}
        </div>
        <div class="groupOwner">
          Grup Sahibi
        </div>
      </div>
      <div class="participantRow" v-for="(participant, index) in group.Admins" :key="index + 'ga'">
        <img :src="getUserPhoto(participant)" alt>
        <div class="participantName">
          {{ getUserNameDisplay(participant) }}
        </div>
        <div class="groupAdmin" :class="{largerMargin: !isGroupOwner}">
          Grup Yöneticisi
        </div>
        <dropdown :is-icon="false" :x="0" :y="0" ref="adminDropdown"
                  v-if="isGroupOwner && !isLDAP"
        >
          <template slot="btn">
            <img class="dropDownBtn" src="@/assets/images/downarrow.png">
          </template>
          <template slot="body">
            <div class="photoMenuItem" @click="removeAdmin(participant)">
              Yöneticilikten Çıkart
            </div>
            <div class="photoMenuItem" @click="removeParticipant(1, participant)">
              Gruptan Çıkar
            </div>
          </template>
        </dropdown>
      </div> -->
      <div class="participantRow" v-for="(participant, index) in groupParticipantsSorted" :key="index + 'gp'">
        <img :src="participant.photo" alt>
        <div class="participantName">
          {{ participant.visibleName }}
        </div>
        <div class="groupAdmin" v-if="isAdmin(participant.userID)" :class="{largerMargin: !isGroupOwner}">
          Grup Yöneticisi
        </div>
        <div class="groupOwner" v-if="isOwner(participant.userID)">
          Grup Sahibi
        </div>
        <dropdown :is-icon="false" :x="0" :y="0" ref="participantDropdown"
                  v-if="isGroupAdmin && !isLDAP"
        >
          <template slot="btn">
            <img class="dropDownBtn" src="@/assets/images/downarrow.png">
          </template>
          <template slot="body">
            <div class="photoMenuItem" @click="makeAdmin(participant.userID)">
              Yönetici Yap
            </div>
            <div class="photoMenuItem" @click="removeParticipant(2, participant.userID)">
              Gruptan Çıkar
            </div>
          </template>
        </dropdown>
      </div>
    </div>

    <div v-if="!isLDAP">
      <div class="leaveGroupDiv" v-if="!group.Deleteds || !group.Deleteds.includes($store.state.session.user.UserID)">
        <div class="leaveGroupLink" @click="sendLeaveGroupMessage(group)">
          Gruptan çık
        </div>
      </div>
      <div class="leaveGroupDiv" v-else>
        <div>Gruptan çıktınız</div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  messageMixin
} from '@/mixins/messageMixin.js'
import {
  socketOutputMixin
} from '@/mixins/socketOutputMixin.js'
import EventBus from '@/eventbus.js'

var vm
export default {
  mixins: [messageMixin, socketOutputMixin],

  data () {
    return {
      uploadFileObj: {},
      isGroupTitleInEditMode: false,
      isGroupDescInEditMode: false,
      isGroupTitleError: false,
      allParticipantsText: 'Bütün Katılımcılar',
      onlyAdminsText: 'Sadece Yöneticiler'
    }
  },

  computed: {
    groupParticipantsSorted () {
      let everybody = []
      if (this.group.Owner !== null) {
        everybody.push(this.group.Owner)
      }
      if (this.group.Participants !== null) {
        for (let index = 0; index < this.group.Participants.length; index++) {
          const element = this.group.Participants[index]
          everybody.push(element)
        }
      }
      if (this.group.Admins !== null) {
        for (let index = 0; index < this.group.Admins.length; index++) {
          const element = this.group.Admins[index]
          everybody.push(element)
        }
      }

      let a = []
      for (let index = 0; index < everybody.length; index++) {
        const userID = everybody[index]
        let item = {
          photo: this.getUserPhoto(userID),
          userID: userID,
          visibleName: this.getUserNameDisplay(userID)

        }
        a.push(item)
      }
      return a.sort(function (a, b) {
        var nameA = a.visibleName.toUpperCase() // ignore upper and lowercase
        var nameB = b.visibleName.toUpperCase() // ignore upper and lowercase
        if (nameA < nameB) {
          return -1
        }
        if (nameA > nameB) {
          return 1
        }

        // names must be equal
        return 0
      })
    },
    group () {
      return this.$store.state.group.groups.find(
        g =>
          g.GroupID ===
          this.$store.state.conversation.activeConversation.GroupID
      )
    },

    participantCount () {
      let participantCount = 0
      if (this.group.Participants) {
        participantCount += this.group.Participants.length
      }
      if (this.group.Admins) {
        participantCount += this.group.Admins.length
      }
      participantCount += 1 // Owner counted

      return participantCount
    },

    cssProps () {
      return {
        '--mainThemeColor': this.$config.theme.default.common.coloredTextColor,
        '--addToGroupColor': this.$config.theme.default.messageContainer.messageBalloon.addToGroupColor
      }
    },

    isGroupAdmin () {
      if (this.group.Admins) {
        return this.group.Owner === this.$store.state.session.user.UserID ||
        this.group.Admins.includes(this.$store.state.session.user.UserID)
      } else {
        return this.group.Owner === this.$store.state.session.user.UserID
      }
    },

    isGroupOwner () {
      return this.group.Owner === this.$store.state.session.user.UserID
    },

    isLDAP () {
      return this.group.isLDAPGroup
    },

    isGroupTitleEditable () {
      return this.isGroupTitleInEditMode && this.isGroupAdmin
    },

    photoURL () {
      let url =
          this.group.PhotoURL
            ? this.group.PhotoURL
            : '/images/groupdefault.png'
      return url
    },

    groupAuthText () {
      return this.group.MessageAuth === 1 ? this.allParticipantsText : this.onlyAdminsText
    }
  },

  methods: {
    isAdmin (userID) {
      for (let index = 0; index < this.group.Admins.length; index++) {
        const element = this.group.Admins[index]
        if (element === userID) {
          return true
        }
      }
      return false
    },
    isOwner (userID) {
      return userID === this.group.Owner
    },
    getUserPhoto (UserID) {
      const userFromStore = this.$store.getters.getUserById(UserID)
      let photoURL = userFromStore ? userFromStore.PhotoURL : null

      if (!photoURL || photoURL === '' || photoURL === null || photoURL === undefined) {
        return '/images/nophoto.png'
      }

      // HTTP URL veya nophoto.png ise direkt döndür
      if (photoURL.includes('http') || photoURL.includes('nophoto.png')) {
        return photoURL
      }

      // Şifrelenmiş dosya URL'si oluştur
      if (this.$config && process.env.VUE_APP_UPLOADURL2) {
        let key = '6a61e395-b49a-4468-bee0-27644e95308f'
        var iv = key
          .split('')
          .reverse()
          .join('')
        let encryptedBody = this.ewk(photoURL, key, iv)
        return process.env.VUE_APP_UPLOADURL2 + '/gfe?fn=' + photoURL + '&s=' + encodeURIComponent(encryptedBody)
      }

      return '/images/nophoto.png'
    },

    groupTitleCheck (event) {
      if (event.target.innerText.trim().length > 0) {
        this.isGroupTitleError = false
      } else {
        this.isGroupTitleError = true
      }
    },

    closeRightColumn () {
      this.$store.state.display.rightSideColumn.isExpanded = false
    },

    openFileDialogInfo () {
      this.$refs.groupPhotoSelectorInfo.click()
    },

    imageFilesSelectedInfo () {
      if (this.$refs.groupPhotoSelectorInfo.files[0]) {
        var reader = new FileReader()
        reader.onload = function (e) {
          vm.group.PhotoURL = e.target.result
          vm.$refs.photoDropDownInfo.isHidden = true
        }
        reader.readAsDataURL(vm.$refs.groupPhotoSelectorInfo.files[0])

        this.uploadGroupImage()
      }
    },

    uploadGroupImage () {
      this.uploadFileObj = JSON.parse(
        JSON.stringify(this.$store.state.message.uploadFileModel)
      )
      this.uploadFileObj.file = this.$refs.groupPhotoSelectorInfo.files[0]
      this.uploadFileObj.processId = this.$uuid.v4()
      this.uploadFileObj.uploadUrl = process.env.VUE_APP_UPLOADURL

      EventBus.$emit('heyManagerUploadThisFile', this.uploadFileObj, 'editGroupImageUploaded')
    },

    uploadManagerUploadedFile (fileObj) {
      this.group.PhotoURL = fileObj.resultURL
      this.sendUpdatedGroupImage()
    },

    sendUpdatedGroupImage () {
      this.updateGroup(this.group)
    },

    makeGroupTitleEditable () {
      let gt = this.$refs.groupTitle
      setTimeout(function () {
        gt.focus()
      }, 0)

      this.isGroupTitleInEditMode = true
    },
    submitGroupTitle () {
      if (!this.isGroupTitleError) {
        let groupTitle = this.$refs.groupTitle.innerText

        var editGrp = { ...this.group }
        editGrp.GroupName = groupTitle
        editGrp.PhotoURL = null

        this.isGroupTitleInEditMode = false
        this.updateGroup(editGrp)
      }
    },

    makeGroupDescEditable () {
      let gd = this.$refs.groupDesc
      setTimeout(function () {
        gd.focus()
      }, 0)

      this.isGroupDescInEditMode = true
    },
    submitGroupDesc () {
      let groupDesc = this.$refs.groupDesc.innerText

      var editGrp = { ...this.group }
      editGrp.GroupDescription = groupDesc
      editGrp.PhotoURL = null

      this.isGroupDescInEditMode = false
      this.updateGroup(editGrp)
    },

    changeGroupAuth (groupAuth) {
      this.$refs.authDropdown.isHidden = true
      this.group.MessageAuth = groupAuth

      var editGrp = { ...this.group }
      editGrp.MessageAuth = groupAuth

      this.updateGroup(editGrp)
    },

    makeAdmin (participant) {
      this.$refs.participantDropdown[0].isHidden = true
      this.sendMakeAdminMessage(participant, this.group)
    },

    removeAdmin (participant) {
      this.$refs.adminDropdown[0].isHidden = true
      this.sendRemoveAdminMessage(participant, this.group)
    },

    removeParticipant (dropdownNumber, participant) {
      if (dropdownNumber === 1) {
        this.$refs.adminDropdown[0].isHidden = true
      } else {
        this.$refs.participantDropdown[0].isHidden = true
      }
      this.sendParticipantRemoveGroupMessage(participant, this.group)
    },

    addToGroup () {
      let owner = [...this.group.Owner]
      let admins = [...this.group.Admins]
      let participants = [...this.group.Participants]
      let oldParticipants = admins ? admins.concat(participants) : participants
      oldParticipants.push(owner)
      this.$store.commit('setOldGroupParticipants', oldParticipants)
      this.$store.commit('resetAdditionalGroupParticipants')

      this.$store.state.display.modal.viewState = 'addToGroup'
      this.$modal.show('homepage')
    }
  },

  created () {
    vm = this
    EventBus.$on(
      'editGroupImageUploaded',
      this.uploadManagerUploadedFile
    )
  },

  beforeDestroy () {
    EventBus.$off('editGroupImageUploaded')
  }
}

</script>

<style lang="less" scoped>
  @error-border-color: rgb(223, 100, 100);
  @border-color: rgb(223, 223, 223);
  @bg-color: rgb(243, 243, 243);

  .groupInfoMain {
    background-color: @bg-color;
    overflow-y: scroll;
    overflow-x: hidden;
    height: calc(100% - 0px);
    border-left: 1px solid @border-color;
    border-right: $border-left;
  }

  .infoBox {
    border-bottom: 1px solid @border-color;
    padding-bottom: 10px;
    background-color: white;
    box-shadow: 10px 10px 10px -16px rgba(0, 0, 0, 0.75);
  }

  .topBar {
    background-color: #eaeceb;
    height: 60px;
    display: flex;
    align-items: center;
    flex-grow: 0;
    flex-shrink: 0;
    border-bottom: @border-color 1px solid;
    border-left: @border-color 1px solid;
  }

  .closeBtn {
    width: 15px;
    height: 15px;
    margin-left: 15px;
    cursor: pointer;
  }

  .barTitle {
    margin-left: 20px;
    font-size: 16px;
  }

  .mainInfoDiv {
    .infoBox;
    text-align: center;
  }

  .groupDescriptionDiv {
    margin-top: 20px;
    min-height: 40px;
    padding-top: 1px;
    .infoBox;

    &>div {
      margin: 10px;
    }

    &>div:first-child {
      color: var(--mainThemeColor);
    }
  }

  .addParticipant {
    color: var(--addToGroupColor);
    cursor: pointer;
  }

  .participantRow {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding-left: 3px;
    padding-right: 3px;
  }

  .profileContainer {
    background-color: #eaeceb;
    width: 100%;
    height: 100%;
  }

  .profilePhotoDiv {
    text-align: center;
    padding-top: 50px;
    position: relative;
  }

  .groupImage {
    margin-top: auto;
    width: 220px;
    height: 220px;
    border-radius: 50%;
    background-color: #fff;
    cursor: pointer;
    object-fit: cover;
  }

  .photoMenuItem {
    padding: 10px;
    font-size: 13px;
    font-weight: 400;
    margin-bottom: 1px;
    background-color: white;
    cursor: pointer;
  }

  .avatarImg {
    margin: auto;
    margin-bottom: 5px;
    width: 220px;
    height: 220px;
    border-radius: 50%;
    background-color: #fff;
    object-fit: cover;
  }

  .photoHover {
    display: block;
    opacity: 0;
    width: 220px;
    height: 220px;
    border-radius: 50%;
    top: calc(50% - 97px);
    left: calc(50% - 110px);
    background-color: RGBA(0, 0, 0, 0.8);
    position: absolute;
    cursor: pointer;
  }

  .photoHover:hover {
    display: block;
    opacity: 1;
  }

  .groupTitleCont {
    display: flex;
    align-items: center;
    margin: 10px;
    margin-bottom: 5px;
    text-align: left;

    &>.editable {
      border-bottom: 1px solid @border-color;
    }

    &>.error {
      border-bottom: 1px solid @error-border-color;
    }
  }

  .groupTitle {
    height: 25px;
    flex-grow: 1;
    flex-shrink: 0;
    border-bottom: 1px solid rgba(0, 0, 0, 0);
  }

  .imgEdit {
    width: 15px;
    height: 15px;
    flex-grow: 0;
    margin-right: 10px;
    cursor: pointer;
  }

  .groupTitle:focus {
    outline: none;
  }

  .createDate {
    color: rgb(165, 165, 165);
    font-size: 13px;
    text-align: left;
    margin-left: 10px;
  }

  .participantRow {
    display: flex;
    align-items: center;
    font-size: 14px;

    &>img:first-child {
      width: 30px;
      height: 30px;
      border-radius: 15px;
      margin-right: 10px;
    }

    &>.participantName {
      flex-grow: 1;
    }

    &>.groupAdmin {
      margin-right: 5px;
      font-size: 11px;
      padding: 2px;
      padding-left: 3px;
      padding-right: 3px;
      border: 1px solid var(--mainThemeColor);
      border-radius: 4px;
      font-weight: 700;
      color: var(--mainThemeColor);
    }

    &>.largerMargin {
      margin-right: 27px;
    }

    &>.groupOwner {
      margin-right: 35px;
      font-size: 11px;
      padding: 2px;
      padding-left: 3px;
      padding-right: 3px;
      border: 1px solid var(--mainThemeColor);
      border-radius: 4px;
      font-weight: 700;
      color: var(--mainThemeColor);
    }
  }

  .dropDownBtn {
    width: 10px;
    height: 10px;
    cursor: pointer;
  }

  .leaveGroupDiv {
    margin-top: 20px;
    padding: 10px;
    .infoBox;

    &>.leaveGroupLink {
      color: red;
      cursor: pointer;
    }
  }

  .groupInfoMain::-webkit-scrollbar {
    width: 2px;
  }

  .groupInfoMain::-webkit-scrollbar-thumb {
    background-color: rgb(155, 155, 155);
  }

  .photoMenuItem:hover {
    background-color: #F0F0F0;
  }
</style>
